import 'jquery';
import * as d3 from 'd3';
import Chart from 'chart.js';
import ChartDeferred from 'chartjs-plugin-deferred';


(function($) {

    $(document).ready(function(){

        initializeChartJS();
    });

    function initializeChartJS() {

        Chart.plugins.register(ChartDeferred);
        initializeFinancialChart();
    }

    var $canvas;
    var labels = [];
    var assets = [];
    var approved = [];
    var paid = [];


    function initializeFinancialChart() {

        $canvas  = $('#chartjs_stacked_financial');

        if ($canvas.length == 1) {
            getDataForFinancialChart().then(function () {
                generateStackedFinancialChart();
            });
        }
    }


    function getCsvUrl() {

        return $canvas.data('csv-url'); // get from data-csv on element
    }

    function getDataForFinancialChart() {

        let csvUrl = getCsvUrl();

        return d3.csv(csvUrl, function(data) {

            if (data['Year']) {
                labels.push(parseInt(data['Year'].replace(/,/g, ''), 10));
                assets.push(parseInt(data['Total Assets'].replace(/,/g, ''), 10));
                approved.push(parseInt(data['Grants Approved'].replace(/,/g, ''), 10));
                paid.push(parseInt(data['Grants Paid'].replace(/,/g, ''), 10));
            }
        });
    }

    function generateStackedFinancialChart() {

        // setting defaults - must happen before rendering chart
        Chart.defaults.global.defaultFontColor = '#7b7b7c';
        Chart.defaults.global.defaultFontSize = 13;
        Chart.defaults.global.defaultFontFamily = '\'Helvetica\', \'Arial\', sans-serif';

        // adjust vertical space between graph and top legend
        Chart.Legend.prototype.afterFit = function() {
            this.height = this.height + 20;
        };

        const data = {
          labels: labels,
          datasets: [
            {
                label: 'Total Assets (left axis) ',
                data: assets,
                borderColor: 'rgba(200, 200, 200, 0.5)',
                //backgroundColor: Utils.transparentize(Utils.CHART_COLORS.red, 0.5),
                backgroundColor: 'rgba(200, 200, 200, 0.5)',
                hoverBackgroundColor: 'rgba(200, 200, 200, .75)',
                stack: 'combined',
                type: 'bar',
                yAxisID: 'B',
            },
            {
                label: 'Grants Approved (right axis) ',
                data: approved,
                borderColor: 'rgba(80, 201, 181, 1)',
                hoverBorderColor: 'rgba(80, 201, 181, 1)',
                backgroundColor: 'rgba(80, 201, 181, 0.2)',
                stack: 'stack',
                type: 'line',
                tension: 0.9, // curviness - can be a function so it moves
                yAxisID: 'A',

            },
            {
                label: 'Grants Paid (right axis) ',
                //data: Utils.numbers(NUMBER_CFG),
                data: paid,
                borderColor: 'rgba(172, 146, 87, 1)',
                hoverBorderColor: 'rgba(172, 146, 87, 1)',
                backgroundColor: 'rgba(172, 146, 87, 1)',
                stack: 'combined',
                type: 'line',
                fill: false, // fills under line
                tension: 0.5, // curviness - can be a function so it moves
                yAxisID: 'A',

            },
          ],
        };

        const config = {
          type: 'line',
          data: data,
          options: {
            layout: {
              padding: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              backgroundColor: 'rgba(60, 60, 60, 0.8)',
              xPadding: 9,
              yPadding: 9,
              caretSize: 10,
              callbacks: {
                label: function (tooltipItem, data) {
                   let label = data.datasets[tooltipItem.datasetIndex].label;
                   label = label.replace(' (right axis)', '');
                   label = label.replace(' (left axis)', '');
                   let value = tooltipItem.yLabel;
                   value = value.toString();
                   value = value.split(/(?=(?:...)*$)/);
                   value = value.join(',');
                   return label + ': $' + value;
                 },
              },
            },
            legend: {
              labels: {
                  // This more specific font property overrides the global property
                  fontColor: '#5e5e5f',
                  fontSize: 20,
                  fontFamily: 'calluna_sans, \'Helvetica\', \'Arial\', \'sans-serif\'',
              },
            },
            plugins: {
              title: {
                display: true,
                text: 'Chart.js Stacked Line/Bar Chart',
              },
              deferred: {
                xOffset: 150,   // defer until 150px of the canvas width are inside the viewport
                yOffset: '100%', // defer until 50% of the canvas height are inside the viewport
                delay: 500,      // delay of 500 ms after the canvas is considered inside the viewport
              },
            },
            scales: {
                xAxes: [{
                    display: true,
                    gridLines: {
                        display: false,
                        color: '#00ff88',
                    },
                    ticks:{
                        display: true,
                        autoSkip: true,
                        maxTicksLimit: 11,
                    },

                }],
                yAxes: [{
                    id: 'A',
                    type: 'linear',
                    position: 'right',
                    gridLines: {
                      display: true,
                      color: '#e3e3e3',
                    },
                    ticks: {
                        fontColor: '#4fc9b5',
                        callback: function (value) {
                            value = value.toString();
                            value = value.split(/(?=(?:...)*$)/);
                            value = value.join(',');
                            return '$' + value;
                          },
                        },
                    },
                    {
                    id: 'B',
                    type: 'linear',
                    position: 'left',
                    gridLines: {
                      display: true,
                      color: '#dcf4f0',
                    },
                    ticks: {
                        fontColor: '#7b7b7c',
                        callback: function (value) {
                            value = value.toString();
                            value = value.split(/(?=(?:...)*$)/);
                            value = value.join(',');
                            return '$' + value;
                            },
                    },
                }],
            },
          },
        };

        var ctx = $canvas;
        new Chart(ctx, config);
    }

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/serenity-charts.js